import { render, staticRenderFns } from "./PostFilter.vue?vue&type=template&id=05e5404e&scoped=true"
import script from "./PostFilter.vue?vue&type=script&lang=js"
export * from "./PostFilter.vue?vue&type=script&lang=js"
import style0 from "./PostFilter.vue?vue&type=style&index=0&id=05e5404e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5404e",
  null
  
)

export default component.exports